<div class="d-flex pt-3">
    <div class="pe-2"><i [ngbTooltip]="'STATUS.MESSAGING' | translate"  [ngClass]="{'link-success':(signalrConnected | async) ==1,'link-danger':(signalrConnected | async)==-1,'link-warning':(signalrConnected | async)==0}" class="fas fa-circle"></i></div>
    <div><i [ngbTooltip]="'STATUS.VOIP' | translate" [ngClass]="{'link-success':(voipConnected | async) ==1,'link-danger':(voipConnected | async)==-1,'link-warning':(voipConnected | async)==0}" class="fas fa-circle"></i></div>
</div>


